import { gql } from "@outschool/ui-apollo";

import EnrollmentPaymentFragment from "./EnrollmentPaymentFragment";
import EnrollmentPaymentRefundFragment from "./EnrollmentPaymentRefundFragment";
import LearnerFragment from "./LearnerFragment";
import { ParentFragment } from "./ParentFragments";

export default gql`
  fragment BaseEnrollmentFragment on BaseEnrollment {
    uid
    parent {
      uid
      ...ParentFragment
    }
    learner {
      uid
      ...LearnerFragment
    }
    buyer {
      uid
      ...ParentFragment
    }
    pricingOffer {
      name
      buyerOrgName
      isFinancialAid
    }
    createdAt
    confirmedAt
    withdrawnAt
    ongoingStoppedAt
    ongoingStartTime
    ongoingEndTime
    canBeWithdrawn
    canBeStopped
    priceCents
    details {
      name
      age
      attendedAt
      message
    }
    payments {
      ...EnrollmentPaymentFragment
      organization {
        ...CharterSchoolFragment
      }
      refunds {
        ...EnrollmentPaymentRefundFragment
      }
    }
    refundableAmountCents
    currency_code
    exchange_rate
    amount_in_local_currency
    refundPolicy {
      type
      name
      description
    }
  }
  ${ParentFragment}
  ${LearnerFragment}
  ${EnrollmentPaymentFragment}
  ${EnrollmentPaymentRefundFragment}
`;
